import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, of, tap } from 'rxjs';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-confirmation-hors-parcours',
  templateUrl: './confirmation-hors-parcours.component.html',
  styleUrls: ['./confirmation-hors-parcours.component.css'],
})
export class ConfirmationHorsParcoursComponent implements OnInit {
  iuf!: string;
  cohorte!: string;
  status!: string;
  confirmed: boolean = false;
  noConfirmed: boolean = false;
  isOldInFODE: boolean = false;
  isNewInFODE: boolean = false;
  serverError: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private spinnerService: SpinnerServiceService,
    private appelsService: AppelsService
  ) {
    this.iuf = this.route.snapshot.params['iuf'];
    this.cohorte = this.route.snapshot.params['cohorte'];
    this.status = this.route.snapshot.params['status'];

    this.spinnerService.showSpinner();
    // console.log('les infos : ', this.iuf, this.cohorte, this.status);
  }
  ngOnInit(): void {
    this.checkConfirmation(this.iuf, this.cohorte);
  }
  checkConfirmation(iuf: string, cohorte: string) {
    this.appelsService
      .offTracksConfirm(iuf, cohorte)
      .pipe(
        tap((confirmationResponse: CustomResponse) => {
          // console.log('confirmation Reponse :', confirmationResponse);
          this.spinnerService.hideSpinner();
          if (confirmationResponse.status == 200) {
            this.noConfirmed = true;
            if (this.status == 'old') {
              this.isOldInFODE = true;
            } else if (this.status == 'new') {
              this.isNewInFODE = true;
            }
          }
        }),
        catchError((error) => {
          // Handle the error here
          console.error('An error occurred:', error.error.httpStatusCode);
          if ((error.error.httpStatusCode = 409)) {
            this.confirmed = true;
            if (this.status == 'old') {
              this.isOldInFODE = true;
            } else if (this.status == 'new') {
              this.isNewInFODE = true;
            }
          } else {
            this.serverError = true;
          }
          return of({
            success: false,
            data: null,
            message: 'Erreur lors de la récupération des données',
          } as CustomResponse);
        })
      )
      .subscribe();
  }
}
